import type { DisciplineCode } from "./taxonomy";
import type { DrawingKind } from "./types";

/**
 * The drawings a new project of each discipline starts with, named as their addresses name them
 * (/p/<project>/design/draft/<id>). The mock's projects have them, and a live project gets them when it is created
 * (WS-29), so a drawing drawn in a demo project in this browser keeps its doc service ID once the same project exists
 * on the server.
 */
export interface StartingDrawing {
  id: string;
  name: string;
  kind: DrawingKind;
}

const DRAWINGS: Readonly<Record<DisciplineCode, readonly [string, DrawingKind][]>> = {
  A: [
    ["Site plan", "site"],
    ["Ground floor plan", "plan"],
    ["First floor plan", "plan"],
    ["Terrace plan", "plan"],
    ["Section A-A", "section"],
    ["Front elevation", "elevation"],
  ],
  I: [
    ["Furniture layout", "plan"],
    ["Reflected ceiling plan", "plan"],
    ["Electrical points", "plan"],
    ["Kitchen elevations", "elevation"],
    ["Wardrobe details", "detail"],
  ],
  L: [
    ["Landscape master plan", "site"],
    ["Planting plan", "plan"],
    ["Grading and drainage", "plan"],
    ["Hardscape details", "detail"],
  ],
  U: [
    ["Layout plan", "layout"],
    ["Plot schedule", "layout"],
    ["Road sections", "section"],
    ["Open space and amenities", "layout"],
  ],
  H: [
    ["Measured ground floor", "plan"],
    ["Condition mapping", "plan"],
    ["Street elevation as found", "elevation"],
  ],
  E: [
    ["Stall plan", "plan"],
    ["Stall elevations", "elevation"],
    ["Fabrication details", "detail"],
  ],
};

/** A drawing's address name: "Section A-A" is section-a-a. */
export function drawingSlug(name: string): string {
  return name.toLowerCase().replace(/[^a-z0-9]+/g, "-");
}

export function startingDrawings(discipline: DisciplineCode): StartingDrawing[] {
  return DRAWINGS[discipline].map(([name, kind]) => ({ id: drawingSlug(name), name, kind }));
}
